import { css } from "theme/default/css";

export const setFlexDFJCSB = css`
  display: flex;
  justify-content: space-between;
`;
